import React, { useLayoutEffect } from "react";
import { BrookshireBrotherLogoWithTagline, GroupLongTermDisabilityClass2Brochure } from "../../../../../assets";
import CoreGltdClass2 from "../../../../../assets/CorePlanImages/CoreGltdClass2Image.avif";
import "./gltdClassB.scss";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";

const GLTDClassB: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<div className="gltd-class-a-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">Group Long Term Disability (Class 02)</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={BrookshireBrotherLogoWithTagline} alt="" />
					</div>
					<div className="plan-description">
						<span>
							Designated full-time employees are automatically enrolled in the company-paid BASIC
							long-term disability benefit where the disability benefit, for an employees who meets
							disability requirements, is 50% of pay, with a maximum of $1,500 per month and the
							disability benefits are taxable. The Class 2 benefit allows salaried employees to increase
							their disability benefit to 60% of pay, with a maximum of $15,000 per month, and the
							disability benefits are non-taxable because the employee pays the very inexpensive premium.
						</span>
					</div>
				</div>
				<div className="right-section">
					<img src={CoreGltdClass2} alt="Core Gltd class 2 image" />
				</div>
			</div>
			<h3 className="sub-heading-title">Plan Brochure</h3>

			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={GroupLongTermDisabilityClass2Brochure} />
			</div>
		</div>
	);
};

export default GLTDClassB;
